//=require ../../../../node_modules/vanilla-cookieconsent/dist/cookieconsent.umd.js

function updateGtagConsent() {

    if (typeof gtag === 'function') {
        gtag('consent', 'update', {
            'ad_storage': CookieConsent.acceptedCategory('advertisement') ? 'granted' : 'denied',
            'ad_user_data': CookieConsent.acceptedCategory('advertisement') ? 'granted' : 'denied',
            'ad_personalization': CookieConsent.acceptedCategory('advertisement') ? 'granted' : 'denied',
            'analytics_storage': CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
            'functionality_storage': CookieConsent.acceptedCategory('functional') ? 'granted' : 'denied',
            'personalization_storage': CookieConsent.acceptedCategory('functional') ? 'granted' : 'denied',
        });
    }

    // Sklik konverze
    window.sznIVA.IS.updateIdentities({
        eid: null
    });
    var retargetingConf = {
        rtgId: 51118,
        consent: CookieConsent.acceptedCategory('analytics') ? 1 : 0
    };
    window.rc.retargetingHit(retargetingConf);

    /*if (typeof sklikConversion === 'function') {
        sklikConversion(CookieConsent.acceptedCategory('analytics') ? 1 : 0);
    }else{
        console.log('nenne');
    }*/
}

CookieConsent.run({

    root: 'body',
    autoShow: true,
    disablePageInteraction: false,
    hideFromBots: true,
    mode: 'opt-in',
    // revision: 0,

    cookie: {
        name: 'cc_cookie',
        // domain: location.hostname,
        // path: '/',
        // sameSite: "Lax",
        expiresAfterDays: 365,
    },

    // https://cookieconsent.orestbida.com/reference/configuration-reference.html#guioptions
    guiOptions: {
        consentModal: {
            layout: 'cloud',
            position: 'bottom center',
            equalWeightButtons: true,
            flipButtons: false
        },
        preferencesModal: {
            layout: 'box',
            equalWeightButtons: true,
            flipButtons: false
        }
    },

    onFirstConsent: ({cookie}) => {
        console.log('onFirstConsent fired', cookie);
    },

    onConsent: ({cookie}) => {
        console.log('onConsent fired!!', cookie);
        updateGtagConsent();
    },

    onChange: ({
                   changedCategories,
                   changedServices
               }) => {
        console.log('onChange fired!', changedCategories, changedServices);
        updateGtagConsent();
    },

    onModalReady: ({modalName}) => {
        console.log('ready:', modalName);
    },

    onModalShow: ({modalName}) => {
        console.log('visible:', modalName);
        updateGtagConsent();
    },

    onModalHide: ({modalName}) => {
        console.log('hidden:', modalName);
    },

    categories: {
        necessary: {
            enabled: true,  // this category is enabled by default
            readOnly: true  // this category cannot be disabled
        },
        analytics: {
            autoClear: {
                cookies: [
                    {
                        name: /^_ga/,   // regex: match all cookies starting with '_ga'
                    },
                    {
                        name: /^_gcl/,   // regex: match all cookies starting with '_ga'
                    },
                    {
                        name: '_gid',   // string: exact cookie name
                    }
                ]
            },

            // https://cookieconsent.orestbida.com/reference/configuration-reference.html#category-services
            services: {
                ga: {
                    label: 'Google Analytics',
                    onAccept: () => {
                    },
                    onReject: () => {
                    }
                }
            }
        },
        functional: {},
        advertisement: {}
    },

    language: {
        default: ACTIVE_LOCALE,
        translations: {
            cs: {
                consentModal: {
                    title: 'Nastavení soukromí',
                    description: 'Na našich webových stránkách používáme soubory cookies. Některé z nich jsou nezbytné, zatímco jiné nám pomáhají vylepšit web a Váš uživatelský zážitek. Souhlasíte s použitím všech cookies?',
                    acceptAllBtn: 'Povolit vše',
                    acceptNecessaryBtn: 'Zamítnout vše',
                    showPreferencesBtn: 'Nechte mě vybrat',
                    // closeIconLabel: 'Reject all and close modal',
                    footer: ``,
                },
                preferencesModal: {
                    title: 'Pokročilá nastavení cookies',
                    acceptAllBtn: 'Povolit vše',
                    acceptNecessaryBtn: 'Zamítnout vše',
                    savePreferencesBtn: 'Povolit vybrané',
                    closeIconLabel: 'Zavřít',
                    serviceCounterLabel: 'Služba|Služby',
                    sections: [
                        {
                            title: 'Vaše možnosti ochrany soukromí',
                            description: `Soubory cookie používáme k zajištění základních funkcí webu a ke zlepšení vašeho online zážitku. Pro každou kategorii si můžete vybrat, zda se chcete dané cookie povolit či zakázat, kdykoli budete chtít.`,
                        },
                        {
                            title: 'Nezbytné a technické cookies',
                            description: 'Tyto soubory cookie jsou nezbytné pro správné fungování našich webových stránek. Bez těchto cookies by web nefungoval správně.',

                            //this field will generate a toggle linked to the 'necessary' category
                            linkedCategory: 'necessary'
                        },
                        {
                            title: 'Funkční cookies',
                            description: 'Tyto soubory cookie sbírají data, jejichž účelem je si pamatovat volby uživatelů, abychom mohli poskytnout lepší a více personalizovanou zkušenost.',
                            linkedCategory: 'functional'
                        },
                        {
                            title: 'Analytické cookies',
                            description: 'Tyto soubory cookies nám pomáhají pochopit chování návštěvníků na našem webu, objevit chyby a poskytnout lepší celkovou analytiku.',
                            linkedCategory: 'analytics',
                            cookieTable: {
                                caption: 'Cookie table',
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Doména'
                                },
                                body: [
                                    {
                                        name: '_ga',
                                        domain: location.hostname
                                    },
                                    {
                                        name: '_gid',
                                        domain: location.hostname
                                    }
                                ]
                            }
                        },
                        {
                            title: 'Marketingové cookies',
                            description: 'Tyto soubory cookies jsou použity ke sledování efektivity reklamních kampaní, abychom mohli poskytnout relevantnější služby.',
                            linkedCategory: 'advertisement',
                            cookieTable: {
                                caption: 'Cookie table',
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Doména'
                                },
                                body: []
                            }
                        }
                    ]
                }
            },
            ru: {
                consentModal: {
                    title: 'Настройки конфиденциальности',
                    description: 'Мы используем файлы cookie на нашем сайте. Некоторые из них необходимы, а другие помогают нам улучшить сайт и удобство его использования. Согласны ли вы на использование всех файлов cookie?',
                    acceptAllBtn: 'Разрешить все',
                    acceptNecessaryBtn: 'Отклонить все',
                    showPreferencesBtn: 'Позвольте мне выбрать',
                    // closeIconLabel: 'Отклонить все и закрыть модальное окно',
                    footer: ``,
                },
                preferencesModal: {
                    title: 'Расширенные настройки файлов cookie',
                    acceptAllBtn: 'Разрешить все',
                    acceptNecessaryBtn: 'Отклонить все',
                    savePreferencesBtn: 'Разрешить выбранное',
                    closeIconLabel: 'Закрыть',
                    serviceCounterLabel: 'Сервис|Услуги',
                    sections: [
                        {
                            title: 'Ваши параметры конфиденциальности',
                            description: `Мы используем файлы cookie, чтобы обеспечить базовую функциональность веб-сайта и улучшить вашу работу в Интернете. Для каждой категории вы можете выбрать, хотите ли вы включить или отключить этот файл cookie в любое время.`,
                        },
                        {
                            title: 'Необходимые и технические файлы cookie',
                            description: 'Эти файлы cookie необходимы для правильной работы нашего веб-сайта. Без этих файлов cookie веб-сайт не будет работать должным образом.',

                            //this field will generate a toggle linked to the 'necessary' category
                            linkedCategory: 'necessary'
                        },
                        {
                            title: 'Функциональные файлы cookie',
                            description: 'Эти файлы cookie собирают данные, цель которых — запомнить выбор пользователя, чтобы мы могли обеспечить лучший и более персонализированный опыт.',
                            linkedCategory: 'functional'
                        },
                        {
                            title: 'Аналитические файлы cookie',
                            description: 'Эти файлы cookie помогают нам понять поведение посетителей на нашем веб-сайте, обнаружить ошибки и обеспечить более качественную общую аналитику.',

                            linkedCategory: 'analytics',
                            cookieTable: {
                                caption: 'Cookie table',
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Doména'
                                },
                                body: [
                                    {
                                        name: '_ga',
                                        domain: location.hostname
                                    },
                                    {
                                        name: '_gid',
                                        domain: location.hostname
                                    }
                                ]
                            }
                        },
                        {
                            title: 'Маркетинговые файлы cookie',
                            description: 'Эти файлы cookie используются для мониторинга эффективности рекламных кампаний, чтобы мы могли предоставлять более актуальные услуги.',
                            linkedCategory: 'advertisement',
                            cookieTable: {
                                caption: 'Cookie table',
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Doména'
                                },
                                body: [
                                ]
                            }
                        }
                    ]
                }
            }
        }
    }
});
